import RechargeQrModal from "./recharge-qr-modal.component";

export * from "./recharge-qr-modal.component";
export default RechargeQrModal;
